import { AfterViewInit, Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Location } from '@angular/common';
import { ApiService } from 'src/app/services/api/api.service';
import { EventsService } from 'src/app/services/events.service';
import { LoadingService } from 'src/app/services/loading.service';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { ToastService } from 'src/app/services/toast.service';


@Component({
  selector: 'app-table-filter',
  templateUrl: './table-filter.component.html',
  styleUrls: ['./table-filter.component.scss'],
  standalone: false
})
export class TableFilterComponent implements OnInit, AfterViewInit, OnDestroy {
  filterForm: any;
  product = '';
  productsArr = []
  public productId = ''
  hospital ='';
  searchInserter: Subscription;
  suggestions: any[] = [];
  isSuggestionsLoading: boolean = false;
  isInserterNameSelected: boolean = false;
  showSuggestions: boolean = false;
  isFilter : boolean =  false;
  destroy$ = new Subject<void>();
  constructor(
    private modal:ModalController,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private location: Location,
    private apiService: ApiService,
    private events: EventsService,
    private loadingService:LoadingService,
    private toastService: ToastService
  ) { }

  ngOnInit() {
    this.hospital = localStorage.getItem('hospital');
    this.createForm()
    this.productType()
  }

  ionViewDidLeave(){
    if (this.searchInserter) {
      this.searchInserter.unsubscribe();
    }
  }

  createForm(){
      this.filterForm = this.fb.group({
        allLines: [''],
        inserterName: [''],
        // activeLines: [''],
        productType: [''],
        insertionDateStart: [''],
        insertionDateEnd: [''],
        skinNick: [''],
        tipPosition: [''],
        insertionTime: [''],
        tourniquet_placed: [''],
        tourniquet_removed: [''],
        correlatedXray: [''],
        successfulInsertion: [''],
        did_x_ray_correlate: ['']
        // dCLines: ['']
      });
      // console.log(this.filterForm.value.inserterName, '1111111111111111111111111')

  }
  productType(){
    this.productId = this.location.path().replace(/^\/+|\/+$/g, '')
    console.log(this.location.path().replace(/^\/+|\/+$/g, ''))
    this.product = this.location.path().replace(/^\/+|\/+$/g, '')
    // this.productsArr = {
    //   arterial : ['Endurance', 'Integrated', 'Quick Flash', 'SAC'],
    //   cvc:[ 'CICC', 'Dialysis'],
    //   midlines:['AGBA', 'Non-AGBA'  ],
    //   dlxrhythm: ['AGBA PICC', 'CVC', 'JACC',' Non-AGBA PICC', 'Stylet Only'  ],
    //   g4picc: ['AGBA PICC', 'JACC',' Non-AGBA PICC', 'Stylet Only']
    // }
    if(this.product == 'arterial'){
      this.productsArr = ['Endurance', 'Integrated', 'Quick Flash', 'SAC']
    }
    else if(this.product == 'cvc'){
      this.productsArr = [ 'CICC', 'Dialysis', 'MAC', 'PSI' ]
    }
    else if(this.product == 'midlines'){
      this.productsArr = ['AGBA', 'Non-AGBA'  ]
    }
    else if(this.product == 'dlx-rhythm'){
      this.productsArr = ['AGBA PICC', 'CVC', 'JACC',' Non-AGBA PICC', 'Stylet Only']
    }
    else if(this.product == 'g4-picc'){
      this.productsArr = ['AGBA PICC', 'JACC',' Non-AGBA PICC', 'Stylet Only']
    }
    else {
      // Default case for "all products" or unknown routes - show all product types
      this.productsArr = [
        'Endurance', 'Integrated', 'Quick Flash', 'SAC',
        'CICC', 'Dialysis', 'MAC', 'PSI',
        'AGBA', 'Non-AGBA',
        'AGBA PICC', 'CVC', 'JACC', 'Non-AGBA PICC', 'Stylet Only'
      ]
    }
    
    // Disable/enable form controls based on product type
    this.updateFormControlsState();
  }
  
  updateFormControlsState() {
    if (!this.filterForm) return;
    
    // Product Type: disabled for 'endurance'
    if (this.product === 'endurance') {
      this.filterForm.get('productType')?.disable();
    } else {
      this.filterForm.get('productType')?.enable();
    }
    
    // Skin Nick: disabled for 'arterial', 'endurance', 'cvc'
    if (this.product === 'arterial' || this.product === 'endurance' || this.product === 'cvc') {
      this.filterForm.get('skinNick')?.disable();
    } else {
      this.filterForm.get('skinNick')?.enable();
    }
    
    // Tip Position: disabled for all except 'dlx-rhythm'
    if (this.product !== 'dlx-rhythm') {
      this.filterForm.get('tipPosition')?.disable();
    } else {
      this.filterForm.get('tipPosition')?.enable();
    }
    
    // Correlated Xray: disabled for 'arterial', 'endurance', 'cvc', 'midlines'
    if (this.product === 'arterial' || this.product === 'endurance' || this.product === 'cvc' || this.product === 'midlines') {
      this.filterForm.get('correlatedXray')?.disable();
    } else {
      this.filterForm.get('correlatedXray')?.enable();
    }
    
    // Did X-Ray Correlate: disabled for 'arterial', 'endurance', 'cvc', 'midlines'
    if (this.product === 'arterial' || this.product === 'endurance' || this.product === 'cvc' || this.product === 'midlines') {
      this.filterForm.get('did_x_ray_correlate')?.disable();
    } else {
      this.filterForm.get('did_x_ray_correlate')?.enable();
    }
    
    // Tourniquet placed/removed: disabled for 'arterial', 'endurance', 'cvc', 'midlines'
    if (this.product === 'arterial' || this.product === 'endurance' || this.product === 'cvc' || this.product === 'midlines') {
      this.filterForm.get('tourniquet_placed')?.disable();
      this.filterForm.get('tourniquet_removed')?.disable();
    } else {
      this.filterForm.get('tourniquet_placed')?.enable();
      this.filterForm.get('tourniquet_removed')?.enable();
    }
  }

  checkInserterNameValidity(): boolean {
    return this.isInserterNameSelected || !!this.suggestions.find(el => el.toLowerCase() === this.filterForm.value.inserterName.toLowerCase());
  }

  async apply() {
    this.isFilter = true
    if(this.filterForm.value.insertionDateStart && !this.filterForm.value.insertionDateEnd){
      return this.toastService.presentErrorToast('Please select insertion date end');
    }
    if(!this.filterForm.value.insertionDateStart && this.filterForm.value.insertionDateEnd){
      return this.toastService.presentErrorToast('Please select insertion date start');
    }
    if(this.filterForm.value.tourniquet_placed && !this.filterForm.value.tourniquet_removed){
      return this.toastService.presentErrorToast('Please select tourniquet removed');
    }
    if(!this.filterForm.value.tourniquet_placed && this.filterForm.value.tourniquet_removed){
      return this.toastService.presentErrorToast('Please select tourniquet placed');
    }
    // if (this.filterForm.value.inserterName && !this.checkInserterNameValidity()) {
    //   this.toastService.presentErrorToast('Invalid Inserter Name');
    //   return;
    // } else {
      await this.loadingService.presentLoading('');
      this.hospital = localStorage.getItem('hospital');

      let product_id = this.productId == 'arterial' ? 1 : this.productId == 'endurance'? 2 : this.productId == 'cvc'? 3 :
      this.productId == 'midlines'? 4 : this.productId == 'dlx-rhythm'? 5 : this.productId == 'g4-picc'? 6 : 0
      let obj = {
        "allLines": this.filterForm.value.allLines == 'all' ? '' : this.filterForm.value.allLines ?? '' ,
        "correlatedXray": this.filterForm.value.correlatedXray == 'all' ? '' : this.filterForm.value.correlatedXray ?? '',
        "inserterName": this.filterForm.value.inserterName ?? '',
        "insertionDateEnd": this.filterForm.value.insertionDateEnd ?? '',
        "insertionDateStart": this.filterForm.value.insertionDateStart ?? '',
        "insertionTime": this.filterForm.value.insertionTime ?? '',
        "productType": this.filterForm.value.productType == 'all' ? '' : this.filterForm.value.productType ?? '',
        "skinNick": this.filterForm.value.skinNick ?? '',
        "successfulInsertion": this.filterForm.value.successfulInsertion ?? '',
        "tipPosition": this.filterForm.value.tipPosition ?? '',
        "tourniquetPlaced": this.filterForm.value.tourniquet_placed ?? '',
        "tourniquetRemoved": this.filterForm.value.tourniquet_removed ?? '',
        "didCorrelated": this.filterForm.value.did_x_ray_correlate ?? ''
      }
      this.apiService.get(`products_insertion/getProductInsertionsbyFilter?hospital_id=${this.hospital}&product_id=${product_id}&product_type=&all_lines=${obj.allLines}&correlated_xray=${obj.correlatedXray}&inserter_name=${obj.inserterName}&insertionDate_end=${obj.insertionDateEnd}&insertionDate_start=${obj.insertionDateStart}&insertion_time=${obj.insertionTime}&product_t=${obj.productType}&skin_nick=${obj.skinNick}&successful_insertion=${obj.successfulInsertion}&tip_position=${obj.tipPosition}&tourniquet_placed=${obj.tourniquetPlaced}&tourniquet_removed=${obj.tourniquetRemoved}&did_x_ray_correlate=${obj.didCorrelated}`).subscribe((res:any) => {
        this.events.publish('filter_data', res);
      });

      this.modal.dismiss();
    // }

  }

  closeModal(){
    // this.filterForm.reset();
    this.modal.dismiss();
    this.showSuggestions = false;
   }
   console(){

   }
   async reset(){
    this.isFilter =! this.isFilter
    this.filterForm = this.fb.group({
      allLines: [''],
      inserterName: [''],
      // activeLines: [''],
      productType: [''],
      insertionDateStart: [''],
      insertionDateEnd: [''],
      skinNick: [''],
      tipPosition: [''],
      insertionTime: [''],
      tourniquet_placed: [''],
      tourniquet_removed: [''],
      successfulInsertion: [''],
      did_x_ray_correlate:[''],
      correlatedXray: [''],
      // dCLines: ['']
    });
    this.updateFormControlsState();
    await this.loadingService.presentLoading('');
      // console.log(this.filterForm.value)
      this.hospital = localStorage.getItem('hospital');
      // console.log(this.productId, 'nmnmmmmmm')

      let product_id = this.productId == 'arterial' ? 1 : this.productId == 'endurance'? 2 : this.productId == 'cvc'? 3 :
      this.productId == 'midlines'? 4 : this.productId == 'dlx-rhythm'? 5 : this.productId == 'g4-picc'? 6 : 0
      let obj = {
        "allLines": this.filterForm.value.allLines ?? '' ,
        "correlatedXray": this.filterForm.value.correlatedXray ?? '',
        "inserterName": this.filterForm.value.inserterName ?? '',
        "insertionDateEnd": this.filterForm.value.insertionDateEnd ?? '',
        "insertionDateStart": this.filterForm.value.insertionDateStart ?? '',
        "insertionTime": this.filterForm.value.insertionTime ?? '',
        "productType": this.filterForm.value.productType ?? '',
        "skinNick": this.filterForm.value.skinNick ?? '',
        "successfulInsertion": this.filterForm.value.successfulInsertion ?? '',
        "tipPosition": this.filterForm.value.tipPosition ?? '',
        "tournquetTimes": this.filterForm.value.tournquetTimes ?? '',
        "didCorrelated": this.filterForm.value.did_x_ray_correlate ?? ''
      }
      this.apiService.get(`products_insertion/getProductInsertionsbyFilter?hospital_id=${this.hospital}&product_id=${product_id}&product_type=&all_lines=${obj.allLines}&correlated_xray=${obj.correlatedXray}&inserter_name=${obj.inserterName}&insertionDate_end=${obj.insertionDateEnd}&insertionDate_start=${obj.insertionDateStart}&insertion_time=${obj.insertionTime}&product_t=${obj.productType}&skin_nick=${obj.skinNick}&successful_insertion=${obj.successfulInsertion}&tip_position=${obj.tipPosition}&tourniquet_time=${obj.tournquetTimes}&did_x_ray_correlate=${obj.didCorrelated}`).subscribe((res:any) => {
        this.events.publish('filter_data', res);
      });
   }
   ngAfterViewInit(){
     this.events.subscribe('leave', (state) => {
      this.filterForm = this.fb.group({
        allLines: [''],
        inserterName: [''],
        // activeLines: [''],
        productType: [''],
        insertionDateStart: [''],
        insertionDateEnd: [''],
        skinNick: [''],
        tipPosition: [''],
        insertionTime: [''],
        tourniquet_placed: [''],
        tourniquet_removed: [''],
        correlatedXray: [''],
        successfulInsertion: [''],
        did_x_ray_correlate: ['']
        // dCLines: ['']
      });
      this.updateFormControlsState();
     });
   }
   updateEndDateMin(): void {
    const startDate = this.filterForm.get('insertionDateStart').value;
    if (startDate) {
      const endDateInput = document.getElementById('end-date') as HTMLInputElement;
      endDateInput.min = startDate;
    }
  }

  selectSuggestion(suggestion: any) {
    this.isSuggestionsLoading = false;
    this.isInserterNameSelected = true;
    this.filterForm.controls['inserterName'].setValue(suggestion);
  }

  onFocusInserterName() {
    this.isInserterNameSelected = false;
    this.showSuggestions = true;
    this.searchInserter = this.filterForm.controls['inserterName'].valueChanges.pipe(
      debounceTime(500),
      takeUntil(this.destroy$)
    ).subscribe(value => {
      if(value[0] == ''){
        value = []
      }
      let data = {
        id: this.hospital,
        name: value
      }
      if (value?.length > 0 && !this.isInserterNameSelected) {
        this.isSuggestionsLoading = true;
        this.apiService.post('users/getUserNames',data).subscribe(async res=>{
          console.log("response ==>",res.data);
          this.isSuggestionsLoading = false;
          this.suggestions = res.data;
          this.showSuggestions = true;
        },
        async (error) => {
          this.suggestions = [];
          this.isSuggestionsLoading = false;
        })
      } else {
        this.suggestions = [];
        this.isSuggestionsLoading = false;
      }
    });
  }

  checkActiveElementClass(ev) {
    const target = ev.target as HTMLElement;
    this.showSuggestions = target.className.includes('active-element');
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.searchInserter) {
      this.searchInserter.unsubscribe();
    }
  }
}
